import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import LogoDark from '../../../images/logo/logo-dark.svg';
import Logo from '../../../images/logo/logo.svg';
import { signInForm } from '../../utils/sign-in';
import { BACKENDS, emailPattern, passwordPattern, setCurrentBackend } from '../../constants';
import { useUser } from '../../utils/use-user';
import { Input } from '../../components/input';

export const SignIn: React.FC = () => {
  const [email, setEmail] = useState<string>(''),
    [password, setPassword] = useState<string>(''),
    [emailError, setEmailError] = useState<string>(''),
    [passwordError, setPasswordError] = useState<string>(''),
    [signInError, setSignInError] = useState<string>(''),
    [selectedBackend, setSelectedBackend] = useState<string>(
        localStorage.getItem('selectedBackend') || 'live'
    ),
    [user] = useUser(),
    handleChangeEmail = (e: any) => {
      const emailValue = e.target.value;
      setEmailError(
        emailPattern.test(emailValue) ? '' : 'Invalid email address',
      );
      setEmail(emailValue);
    },
    handleChangePassword = (e: any) => {
      const passwordValue = e.target.value;

      setPasswordError(
        passwordPattern.test(passwordValue)
          ? ''
          : 'Password must be at least 8 characters long and contain at least one uppercase letter and one non-alphanumeric character',
      );
      setPassword(passwordValue);
    },

    handleBackendChange = async (e: React.ChangeEvent<HTMLSelectElement>) => {
      const backend = e.target.value;
      setSelectedBackend(backend);
      setCurrentBackend(backend);
    },

    navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate('/');
    }
  }, [navigate, user]);

  const handleSubmit = async (event: any) => {
    event.preventDefault();

    const data = {
      email: email,
      password: password,
    };
    await signInForm('/users/login-admin', data, navigate, setSignInError);
  };

  return (
    <div className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
      <div className="flex flex-wrap items-center">
        <div className="w-full border-stroke dark:border-strokedark xl:w-1/2 xl:border-l-2">
          <div className="w-full p-4 sm:p-12.5 xl:p-17.5">
            <span className="mb-1.5 block font-medium">Start for free</span>

            <h2 className="mb-9 text-2xl font-bold text-black dark:text-white sm:text-title-xl2">
              Sign In to TailAdmin
            </h2>

            <form onSubmit={handleSubmit}>
              <div className="mb-1">
                <Input
                  lable="Email"
                  onChange={handleChangeEmail}
                  placeholder="Enter your email"
                  type="email"
                  value={email}
                />
              </div>

              <span className="mb-5 block font-medium text-red-900">
                {emailError}
              </span>

              <div className="mb-1">
                <Input
                  lable="Password"
                  onChange={handleChangePassword}
                  placeholder="Enter your password"
                  type="password"
                  value={password}
                />
              </div>

              <span className="mb-5 block font-medium text-red-900">
                {passwordError}
              </span>
              <div className="mb-4">
                <label htmlFor="backend" className="mb-2.5 block font-medium text-black dark:text-white">
                  Backend Environment
                </label>
                <select
                    id="backend"
                    value={selectedBackend}
                    onChange={handleBackendChange}
                    className="w-full rounded-lg border border-stroke bg-transparent py-3 px-5 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
                >
                  {Object.keys(BACKENDS).map((key) => (
                      <option key={key} value={key}>
                        {key?.toUpperCase()}
                      </option>
                  ))}
                </select>
              </div>
              
              {/* Error message displayed before the button */}
              {signInError && (
                <div 
                  className="mb-4 p-3 bg-red-100 border-2 border-red-500 rounded-lg"
                  style={{ backgroundColor: '#fef2f2', borderColor: '#ef4444', color: '#dc2626' }}
                >
                  <span className="text-red-600 font-semibold text-sm" style={{ color: '#dc2626' }}>
                    {signInError}
                  </span>
                </div>
              )}
              
              <div className="mb-5">
                <input
                  className="w-full cursor-pointer rounded-lg border border-primary bg-primary p-4 text-white transition hover:bg-opacity-90"
                  type="submit"
                  value="Sign In"
                />
              </div>

              <div className="mt-6 text-center">
                <p>
                  Don’t have any account?{' '}
                  <Link to="/signup" className="text-primary">
                    Sign Up
                  </Link>
                </p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
